
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { FaRegCircleUser, FaBoxOpen } from "react-icons/fa6";
import { FaUsers, FaTachometerAlt, FaClipboardList } from "react-icons/fa";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import ROLE from "../common/role";

const AdminPanel = () => {
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.role !== ROLE.ADMIN) {
      navigate("/");
    }
  }, [user]);

  const linkClass =
    "flex items-center gap-2 px-3 py-2 rounded hover:bg-red-50 transition";

  const activeClass = "bg-red-100 text-red-600 font-medium";

  return (
    <div className="min-h-[calc(100vh-120px)] flex bg-gray-100">

      {/* Sidebar */}
      <aside className="bg-white w-64 shadow-md p-4 hidden md:block">

        <div className="flex flex-col items-center border-b pb-4 mb-4">
          <div className="text-5xl">
            {user?.profilePic ? (
              <img
                src={user?.profilePic}
                className="w-20 h-20 rounded-full"
                alt={user?.name}
              />
            ) : (
              <FaRegCircleUser />
            )}
          </div>
          <p className="capitalize font-semibold mt-2">{user?.name}</p>
          <p className="text-sm text-gray-500">{user?.role}</p>
        </div>

        <nav className="flex flex-col gap-2 text-sm">

          <NavLink
            to="dashboard"
            className={({ isActive }) =>
              `${linkClass} ${isActive ? activeClass : ""}`
            }
          >
            <FaTachometerAlt /> Dashboard
          </NavLink>

          <NavLink
            to="all-users"
            className={({ isActive }) =>
              `${linkClass} ${isActive ? activeClass : ""}`
            }
          >
            <FaUsers /> Users
          </NavLink>

          <NavLink
            to="all-products"
            className={({ isActive }) =>
              `${linkClass} ${isActive ? activeClass : ""}`
            }
          >
            <FaBoxOpen /> Products
          </NavLink>

          <NavLink
            to="orders"
            className={({ isActive }) =>
              `${linkClass} ${isActive ? activeClass : ""}`
            }
          >
            <FaClipboardList /> Orders
          </NavLink>

        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-6">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminPanel;